module.exports = __webpack_public_path__ + "img/mountains.bc088db5.jpeg";